import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Lock, Mail, AlertCircle, Shield } from 'lucide-react';
import { motion } from 'framer-motion';
import { authAPI } from '../../services/api';

const AdminLogin = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      const response = await authAPI.login({ email, password });
      const { access_token, user } = response.data;
      
      if (user.role !== 'admin') {
        setError('Accès réservé aux administrateurs');
        return;
      }

      localStorage.setItem('auth_token', access_token);
      navigate('/admin');
      window.location.reload();
    } catch (err) {
      setError(err.response?.data?.detail || 'Identifiants invalides');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div 
      className="min-h-screen flex items-center justify-center px-4"
      style={{
        backgroundImage: 'url(https://customer-assets.emergentagent.com/job_2bde1c9b-86e8-45d3-80bd-0f0476a263ab/artifacts/ur3i0a8o_BAckground.png)',
        backgroundSize: 'cover',
        backgroundPosition: 'center',
      }}
      data-testid="admin-login-page"
    >
      <div className="absolute inset-0 bg-[#0A0A0B]/90" />
      
      <motion.div
        initial={{ opacity: 0, y: 30 }}
        animate={{ opacity: 1, y: 0 }}
        className="relative z-10 w-full max-w-md"
      >
        <div className="bg-[#1A1A1D] p-10 rounded-lg metallic-border cyber-glow">
          <div className="text-center mb-8">
            <div className="inline-block p-4 bg-[#00FFFF]/10 rounded-full mb-4">
              <Shield className="h-12 w-12 text-[#00FFFF]" />
            </div>
            <h1 className="text-3xl font-bold text-white mb-2">Administration IPTV4KFR</h1>
            <p className="text-[#B8B8BA]">Accès réservé aux administrateurs</p>
          </div>

          {error && (
            <div className="bg-[#FF3B5C]/10 border border-[#FF3B5C] rounded-lg p-4 mb-6 flex items-start space-x-3">
              <AlertCircle className="h-5 w-5 text-[#FF3B5C] flex-shrink-0 mt-0.5" />
              <span className="text-[#FF3B5C] text-sm">{error}</span>
            </div>
          )}

          <form onSubmit={handleSubmit} className="space-y-6">
            <div>
              <label className="block text-[#E8E8E8] font-medium mb-2">Email administrateur</label>
              <div className="relative">
                <Mail className="absolute left-3 top-1/2 -translate-y-1/2 h-5 w-5 text-[#B8B8BA]" />
                <input
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  className="w-full bg-[#222226] border border-[#3A3A3D] rounded-lg pl-12 pr-4 py-3 text-white focus:border-[#00FFFF] focus:outline-none"
                  placeholder="admin@iptv4kfr.com"
                  required
                  data-testid="admin-email-input"
                />
              </div>
            </div>

            <div>
              <label className="block text-[#E8E8E8] font-medium mb-2">Mot de passe</label>
              <div className="relative">
                <Lock className="absolute left-3 top-1/2 -translate-y-1/2 h-5 w-5 text-[#B8B8BA]" />
                <input
                  type="password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  className="w-full bg-[#222226] border border-[#3A3A3D] rounded-lg pl-12 pr-4 py-3 text-white focus:border-[#00FFFF] focus:outline-none"
                  placeholder="••••••••"
                  required
                  data-testid="admin-password-input"
                />
              </div>
            </div>

            <button
              type="submit"
              disabled={loading}
              className="w-full btn-primary cyber-glow-hover disabled:opacity-50"
              data-testid="admin-submit-button"
            >
              {loading ? 'Connexion...' : 'Accéder au back-office'}
            </button>
          </form>
        </div>
      </motion.div>
    </div>
  );
};

export default AdminLogin;